import { OPEN_AUDIENCE_ORG_UID } from '@openx/utils/services/config';
import type { Session } from '../components/AuthContext/types';

const Role = {
  ADMIN: 'admin',
  MEMBER: 'member',
} as const;

export function isAdmin(session?: Session | null): boolean {
  return session?.role === Role.ADMIN;
}

export function isInternalUser(session?: Session | null): boolean {
  if (!session) {
    return false;
  }
  return session.account.parent_account_id === null;
}

export function isInternalAdmin(session?: Session | null): boolean {
  return isAdmin(session) && isInternalUser(session);
}

export const isMasterOrganisation = (session: null | undefined | Session) => {
  return !!session && session.exchange_session.account.uid === OPEN_AUDIENCE_ORG_UID;
};
